import BaseComponent from './BaseComponent.js'

export default class CozyCommand extends BaseComponent {

  static get is() { return 'command' }

  get styles() {
    return `
      :host {
        cursor: pointer;
        transition: all 0.2s ease-in-out;
        will-change: transform;
        transform-origin: center;
        font-weight: bold;
        font-size: 1.1em;
      }
      :host(:hover) {
        filter: hue-rotate(20deg);
        transform: scale(1.05);
      }
      :host span {
        display: inline-flex;
        align-items: center;
      }
      :host i {
        display: inline-block;
        font-family: monospace;
        padding: 0 .1em;
        color: #52C7EF;
      }
    `
  }

  get commandText() {
    return `/${this.params[0] || ''}`
  }

  mounted() {
    this.addEventListener('click', this.#onClick)
  }

  unmounted() {
    this.removeEventListener('click', this.#onClick)
  }

  updated() {
    this.componentHtml = `
      <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.3252 3.05011L8.66765 20.4323L10.5995 20.9499L15.257 3.56775L13.3252 3.05011Z" fill="currentColor"/>
        <path d="M7.61222 18.3608L8.97161 16.9124L8.9711 16.8933L3.87681 12.1121L8.66724 7.00798L7.20892 5.63928L1.0498 12.2017L7.61222 18.3608Z" fill="currentColor"/>
        <path d="M16.3883 18.3608L15.0289 16.9124L15.0294 16.8933L20.1237 12.1121L15.3333 7.00798L16.7916 5.63928L22.9507 12.2017L16.3883 18.3608Z" fill="currentColor"/>
      </svg>
      <i>${this.commandText}</i>
    `
    this.setComponentAttribute('title', `Click to copy: ${this.commandText}`)
  }

  #onClick() {
    navigator.clipboard.writeText(this.commandText)
      .then(() => { console.log(`Copied to clipboard: ${this.commandText}`) })
      .catch((err) => { console.error('Failed to copy text: ', err) })
  }
}
